module.exports = __webpack_public_path__ + "fonts/proxima_nova_regular-webfont.fd7b6e15.woff2";